import DominoConfig from '@components/dominoConfig/DominoConfig'
import { Venue as VenueModel } from '@models/Venue'
import { useAppSelector } from '@store/hooks'
import { selectVenueById } from '@store/VenueReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'

type Props = SBModelComponent<VenueModel> & {
  //
}

export const VenueDominoConfig = ({ id, model }: Props) => {
  const venue = model ? model : useAppSelector(selectVenueById(id!))

  if (!venue) {
    return <></>
  }

  if (!venue.dominoConfig) {
    return (
      <SBRM.Actions
        entity={Entity.dominoConfig}
        actions={[SBRMAction.Create]}
        metadata={[{ key: MetadataKey.Venue, value: venue.id }]}
      />
    )
  }

  return <DominoConfig.Avatar id={venue.dominoConfig} />
}

export type VenueDominoConfigType = { DominoConfig: typeof VenueDominoConfig }
